import script from "./MarkTip.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarkTip.vue?vue&type=script&setup=true&lang=ts"

import "./MarkTip.vue?vue&type=style&index=0&id=732b923b&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-732b923b"]])

export default __exports__